const VIRTUMED_WPP_NUMBER = "5511968969999";
const API_MAIL_URL =
  "https://fcrot3fcqh.execute-api.sa-east-1.amazonaws.com/dev/mail";

export { API_MAIL_URL, VIRTUMED_WPP_NUMBER };
